const IN_APP = /Instagram|FBAN|FBAV|FB_IAB|Line\/|TikTok|BytedanceWebview|Twitter/i;

export function isInAppBrowser(ua: string): boolean {
  return IN_APP.test(ua);
}

/** Instagram Android/iOS menü adları farklı; diğer uygulama içi tarayıcılarda genel uyarı. */
export function inAppBrowserHint(ua: string): string {
  const instagram = /Instagram/i.test(ua);
  const ios = /iPhone|iPad|iPod/i.test(ua);
  if (instagram && ios) return 'Instagram iç tarayıcısında kayıt sorun çıkarabilir. Alttaki ⋯ menüsünden "Safari\'de Aç"ı seçin.';
  if (instagram) return 'Instagram iç tarayıcısında kayıt sorun çıkarabilir. Sağ üstteki ⋯ menüsünden "Tarayıcıda aç"ı seçin.';
  return 'Uygulama içi tarayıcıda kayıt ve giriş sorun çıkarabilir. Sayfayı Chrome veya Safari\'de açın.';
}

export function showInAppBrowserWarning(el: HTMLElement, ua = navigator.userAgent): void {
  if (!isInAppBrowser(ua)) return;
  el.textContent = inAppBrowserHint(ua);
  el.classList.remove('hidden');
}
